import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  imports: [MDBBootstrapModulesPro.forRoot(), DropdownModule.forRoot(), RouterModule, NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }), NgxSliderModule, FileUploadModule],
  exports: [
    FormsModule,
    CommonModule,
    NgbModule,
    InfiniteScrollModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    TranslateModule,
    MDBBootstrapModulesPro,
    RouterModule,
    NgxSpinnerModule,
    NgxSliderModule,
    FileUploadModule,
  ],
})
export class SharedLibsModule {}
